import { render, staticRenderFns } from "./Quota.vue?vue&type=template&id=50dc6a64"
import script from "./Quota.vue?vue&type=script&lang=js"
export * from "./Quota.vue?vue&type=script&lang=js"
import style0 from "./Quota.vue?vue&type=style&index=0&id=50dc6a64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports